import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi, { x } from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DailyCropDetailsReportSchema } from "../DailyCropDetailsReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Box from "@material-ui/core/Box";

const screenCode = 'DAILYCROPDETAILSREPORT'

const useStyles = makeStyles({
    table: {
        minWidth: 650,
        borderCollapse: 'collapse',
    },
    dialog1: {
        width: 850,
    },
    stickyHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'white',
        borderLeft: '1px solid #ddd',
        borderTop: '1px solid #ddd',
        borderRight: '1px solid #ddd',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
        borderLeft: '1px solid #ddd',
        borderTop: '1px solid #ddd',
        borderBottom: '1px solid #ddd',
    },
});

export function DailyCropDetailsReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        month: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(DailyCropDetailsReportSchema).options({ allowUnknown: true });
    const [reportData, setReportData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });
    const [daysArray, setDaysArray] = useState([]);
    const modifiedReportData = {};
    const [totalValues, setTotalValues] = useState({
        totalEstateCropDay: 0,
        totalRevenueLatex: 0,
        totalRevenueScrap: 0,
        totalRevenueCombined: 0,
        totalAbandonedLatex: 0,
        totalAbandonedScrap: 0,
        totalAbandonedTotal: 0,
        totalRevenueAbandonedTotal: 0
    });
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        setDaysArray(MonthDays(searchData.month));
    }, [searchData.month]);

    useEffect(() => {
        if (reportData.length != 0) {
            calculateTotal()
        }
    }, [reportData]);

    useEffect(() => {
        setReportData([]);
        setsearchData({
            ...searchData,
            month: "",
            operationEntityID: "0"
        });
    }, [searchData.groupID]);

    useEffect(() => {
        setReportData([]);
        setsearchData({
            ...searchData,
            month: "",
        });
    }, [searchData.operationEntityID]);

    useEffect(() => {
        setReportData([])
    }, [searchData.month]);


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYCROPDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setsearchData({
                ...searchData,
                groupID: token.groupID
            });

        } else {
            setsearchData({
                ...searchData,
                groupID: "0",
                operationEntityID: "0"
            });
        }


        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyCropDetailsReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const reportData = await service.GetReportData(searchData.operationEntityID, searchData.month);
        var incrementalValue = 0;
        reportData.forEach(row => {
            incrementalValue += row.estateCropDay
            row.estateCropToDate = incrementalValue
        });

        var incrementaltappersToDateValue = 0;
        reportData.forEach(row => {
            incrementaltappersToDateValue += row.tappersDay
            row.tappersToDate = incrementaltappersToDateValue
        });

        setReportData(reportData)
        setSelectedSearchData();


        reportData.forEach(row => {
            const { day } = row;
            if (!modifiedReportData[day]) {
                modifiedReportData[day] = [row];
            } else {
                modifiedReportData[day].push(row);
            }
        });
    }


    function calculateTotal() {

        const totalEstateCropDay = reportData.reduce((accumulator, current) => {
            const progressFraction = current.estateCropDay;
            return accumulator + progressFraction;
        }, 0);

        const totalRevenueLatex = reportData.reduce((accumulator, current) => {
            const progressFraction = current.revenueLatex;
            return accumulator + progressFraction;
        }, 0);

        const totalRevenueScrap = reportData.reduce((accumulator, current) => {
            const progressFraction = Math.floor(current.revenueScrap);
            return accumulator + progressFraction;
        }, 0);

        const totalRevenueCombined = reportData.reduce((accumulator, current) => {
            const cropTotal = parseFloat(getRevenueCombined(current));
            return accumulator + cropTotal;
        }, 0);

        const totalAbandonedLatex = reportData.reduce((accumulator, current) => {
            const progressFraction = current.abandonedLatex;
            return accumulator + progressFraction;
        }, 0);

        const totalAbandonedScrap = reportData.reduce((accumulator, current) => {
            const progressFraction = Math.floor(current.abandonedScrap);
            return accumulator + progressFraction;
        }, 0);

        const totalAbandonedTotal = reportData.reduce((accumulator, current) => {
            const cropTotal = parseFloat(getAbandonedTotal(current));
            return accumulator + cropTotal;
        }, 0);

        const totalRevenueAbandonedTotal = reportData.reduce((accumulator, current) => {
            const cropTotal = parseFloat(getRevenueAbandonedTotal(current));
            return accumulator + cropTotal;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalEstateCropDay: totalEstateCropDay,
            totalRevenueLatex: totalRevenueLatex,
            totalRevenueScrap: totalRevenueScrap,
            totalRevenueCombined: totalRevenueCombined,
            totalAbandonedLatex: totalAbandonedLatex,
            totalAbandonedScrap: totalAbandonedScrap,
            totalAbandonedTotal: totalAbandonedTotal,
            totalRevenueAbandonedTotal: totalRevenueAbandonedTotal
        });
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            month: searchData.month
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var intakeDay = getIntakeDay(x);
                var intakeTodate = getIntakeTodate(x);
                var revenueCombined = getRevenueCombined(x);
                var abandonedTotal = getAbandonedTotal(x);
                var revenueAbandonedTotal = getRevenueAbandonedTotal(x);

                var vr = {
                    'DATE': x.day,
                    'ESTATE CROP  - ACTUAL - DAY': x.estateCropDay,
                    'ESTATE CROP  - ACTUAL - TODATE': x.estateCropToDate,
                    'Y.P.H - DAY': '-',
                    'Y.P.H - TODATE': '-',
                    'TAPPERS - DAY': x.tappersDay,
                    'TAPPERS - TODATE': x.tappersToDate,
                    'INTAKE - DAY': intakeDay,
                    'INTAKE - TODATE': intakeTodate,
                    'Tappers Out Turn % - To be Taped': '-',
                    'Tappers Out Turn % - Blocked Taped': '-',
                    'Tappers Out Turn % - Out Turn %': '-',
                    'VACANT BLOCK - DAY': '-',
                    'VACANT BLOCK - TODATE': '-',
                    'REVENUE CROP - KGS - Latex': x.revenueLatex,
                    'REVENUE CROP - KGS - Scrap': x.revenueScrap,
                    'REVENUE CROP - KGS - Combined': revenueCombined,
                    'Abandoned Crop - Latex': x.abandonedLatex,
                    'Abandoned Crop - Scrap': x.abandonedScrap,
                    'Abandoned Crop - Total': abandonedTotal,
                    'TOTAL - Rev + aban': revenueAbandonedTotal,

                };
                res.push(vr);
            });

            var totalEstateCropDay = totalValues.totalEstateCropDay;
            var totalRevenueLatex = totalValues.totalRevenueLatex;
            var totalRevenueScrap = totalValues.totalRevenueScrap;
            var totalRevenueCombined = totalValues.totalRevenueCombined;
            var totalAbandonedLatex = totalValues.totalAbandonedLatex;
            var totalAbandonedScrap = totalValues.totalAbandonedScrap;
            var totalAbandonedTotal = totalValues.totalAbandonedTotal;
            var totalRevenueAbandonedTotal = totalValues.totalRevenueAbandonedTotal

            var vr = {
                'DATE': 'Total',
                'ESTATE CROP  - ACTUAL - DAY': totalEstateCropDay,
                'ESTATE CROP  - ACTUAL - TODATE': '-',
                'Y.P.H - DAY': '-',
                'Y.P.H - TODATE': '-',
                'TAPPERS - DAY': '-',
                'TAPPERS - TODATE': '-',
                'INTAKE - DAY': '-',
                'INTAKE - TODATE': '-',
                'Tappers Out Turn % - To be Taped': '-',
                'Tappers Out Turn % - Blocked Taped': '-',
                'Tappers Out Turn % - Out Turn %': '-',
                'VACANT BLOCK - DAY': '-',
                'VACANT BLOCK - TODATE': '-',
                'REVENUE CROP - KGS - Latex': totalRevenueLatex,
                'REVENUE CROP - KGS - Scrap': totalRevenueScrap,
                'REVENUE CROP - KGS - Combined': totalRevenueCombined,
                'Abandoned Crop - Latex': totalAbandonedLatex,
                'Abandoned Crop - Scrap': totalAbandonedScrap,
                'Abandoned Crop - Total': totalAbandonedTotal,
                'TOTAL - Rev + aban': totalRevenueAbandonedTotal,
            };
            res.push(vr);
            res.push([]);

            var vr = {
                'DATE': 'Group : ' + selectedSearchValues.group,
                'ESTATE CROP  - ACTUAL - DAY': 'Estate : ' + selectedSearchValues.estate,
                'ESTATE CROP  - ACTUAL - TODATE': 'Month : ' + selectedSearchValues.month,
            };
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(reportData);

        var settings = {
            sheetName: 'Daily Crop Details Report',
            fileName: 'Daily Crop Details Report',
            writeOptions: {}
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        xlsx(csvHeaders, file, settings, true);
    }

    function MonthDays(month) {
        const year = parseInt(moment(month, "YYYY-MM").format('YYYY'));
        const monthNumber = parseInt(moment(month, "YYYY-MM").format('M')) - 1;

        function daysInMonth(year, month) {
            return new Date(year, month + 1, 0).getDate();
        }

        const totalDays = daysInMonth(year, monthNumber);
        const daysArray = Array.from({ length: totalDays }, (_, i) => i + 1);
        return daysArray;
    }

    const getIntakeDay = (row) => {
        const estateCropDay = row.estateCropDay;
        const tappersDay = row.tappersDay;
        const intakeDay = estateCropDay / tappersDay;
        return Number(intakeDay.toFixed(2));
    }

    const getIntakeTodate = (row) => {
        const estateCropTodate = row.estateCropToDate;
        const tappersTodate = row.tappersToDate;
        const intakeTodate = estateCropTodate / tappersTodate;
        return Number(intakeTodate.toFixed(2));
    }

    const getRevenueCombined = (row) => {
        const revenueLatex = row.revenueLatex;
        const revenueScrap = row.revenueScrap;
        const revenueCombined = revenueLatex + revenueScrap;
        return revenueCombined;
    }

    const getAbandonedTotal = (row) => {
        const abandonedLatex = row.abandonedLatex;
        const abandonedScrap = row.abandonedScrap;
        const abandonedTotal = abandonedLatex + abandonedScrap;
        return abandonedTotal;
    }

    const getRevenueAbandonedTotal = (row) => {
        const revenueCombined = getRevenueCombined(row);
        const abandonedTotal = getAbandonedTotal(row);
        const revenueAbandonedTotal = revenueCombined + abandonedTotal;
        return revenueAbandonedTotal;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Crop Details Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(
                                            Object.fromEntries(
                                                Object.entries(operationEntity).filter(([key, value]) => {
                                                    if (key === "0" || !value) return false;
                                                    if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                        return true;
                                                    }
                                                    return Object.values(multipleEstates).includes(value);
                                                })
                                            )
                                        )}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="month"
                                        label="Month *"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        value={searchData.month}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Box display="flex" justifyContent="flex-end" >
                                                <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                    <Table className={classes.table} size="small" aria-label="sticky table" stickyHeaderstyle={{ borderCollapse: 'collapse', border: "2px", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} >
                                                        <TableHead className={`${classes.stickyHeader}`}>
                                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Check roll weight
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Factory Weight
                                                                </TableCell>
                                                                <TableCell colSpan={15}></TableCell>
                                                            </TableRow>
                                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DATE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    ESTATE CROP - ACTUAL
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Y.P.H
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TAPPERS
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    INTAKE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Tappers Out Turn %
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    VACANT BLOCK
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    REVENUE CROP - KGS
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Abandoned Crop
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TOTAL
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DAY
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TODATE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DAY
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TODATE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DAY
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TODATE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DAY
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TODATE
                                                                </TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    To be Taped
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Blocked taped
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Out Turn %
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    DAY
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    TODATE
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Latex
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Scrap
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Combined
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Latex
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Scrap
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Total
                                                                </TableCell>
                                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                                    Rev + aban
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {reportData.map(row => (
                                                                <TableRow >
                                                                    <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                                        {row.day}
                                                                    </TableCell>
                                                                    <React.Fragment >
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.estateCropDay) || row.estateCropDay == 0 ? '-' : (row.estateCropDay).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.estateCropToDate) || row.estateCropToDate == 0 ? '-' : (row.estateCropToDate).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*YPHDAY */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*YPHTODATE */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.tappersDay) || row.tappersDay == 0 ? '-' : (row.tappersDay.toFixed(2))}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.tappersToDate) || row.tappersToDate == 0 ? '-' : (row.tappersToDate).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(getIntakeDay(row)) || getIntakeDay(row) == 0 ? '-' : (getIntakeDay(row)).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(getIntakeTodate(row)) || getIntakeTodate(row) == 0 ? '-' : (getIntakeTodate(row)).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*TAPPERSOUTTURN */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*TAPPERSOUTTURN */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*TAPPERSOUTTURN */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*VACANTBLOCK */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {/*VACANTBLOCK */}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.revenueLatex) || row.revenueLatex == 0 ? '-' : (row.revenueLatex).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.revenueScrap) || row.revenueScrap == 0 ? '-' : (row.revenueScrap).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(getRevenueCombined(row)) || getRevenueCombined(row) == 0 ? '-' : (getRevenueCombined(row)).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.abandonedLatex) || row.abandonedLatex == 0 ? '-' : (row.abandonedLatex).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(row.abandonedScrap) || row.abandonedScrap == 0 ? '-' : (row.abandonedScrap).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(getAbandonedTotal(row)) || getAbandonedTotal(row) == 0 ? '-' : (getAbandonedTotal(row)).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                            {isNaN(getRevenueAbandonedTotal(row)) || getRevenueAbandonedTotal(row) == 0 ? '-' : (getRevenueAbandonedTotal(row)).toFixed(2)}
                                                                        </TableCell>
                                                                    </React.Fragment>

                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        <TableBody>
                                                            <TableRow style={{ border: "2px solid black" }}>
                                                                <TableCell style={{ borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="left">
                                                                    Total
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalEstateCropDay == 0 ? '-' : (totalValues.totalEstateCropDay).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    { }
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*YPHDAY */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*YPHTODATE */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    { }
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*TAPPERSTODATE */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*INTAKE DAY */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*INTAKE TODATE */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*TAPPERSOUTTURN */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*TAPPERSOUTTURN */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*TAPPERSOUTTURN */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*VACANTBLOCK */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {/*VACANTBLOCK */}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalRevenueLatex == 0 ? '-' : (totalValues.totalRevenueLatex).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalRevenueScrap == 0 ? '-' : (totalValues.totalRevenueScrap).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalRevenueCombined == 0 ? '-' : (totalValues.totalRevenueCombined).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalAbandonedLatex == 0 ? '-' : (totalValues.totalAbandonedLatex).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalAbandonedScrap == 0 ? '-' : (totalValues.totalAbandonedScrap).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalAbandonedTotal == 0 ? '-' : (totalValues.totalAbandonedTotal).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                                    {totalValues.totalRevenueAbandonedTotal == 0 ? '-' : (totalValues.totalRevenueAbandonedTotal).toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <div>&nbsp;</div>
                                    <style>
                                        {`
                                            @page {
                                                size: A4 landscape;
                                                margin: 10mm;
                                            }
                                        `}
                                    </style>
                                    <ReactToPrint
                                        trigger={() => (
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Create PDF"
                                            />
                                        )}
                                        content={() => componentRef.current}
                                        documentTitle={'Daily Crop Details Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} reportData={reportData}
                                            selectedSearchValues={selectedSearchValues} totalValues={totalValues} daysArray={daysArray} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}